<template>
  <div class="general">
    <table-cadu
      custom
      v-model="selected"
      nameTab="consultarUnimed"
      :class="$vuetify.breakpoint.xs ? 'mandatos-mobile' : 'mandatos'"
      :loading="isLoading"
      :append-icon="'$vuetify.icons.chevron-down'"
      :showCheck="false"
      :showFiltro="false"
      :showSelectItens="false"
      :rows="listaUnimeds"
      :rowsHeader="rowsHeader"
      :items="['10']"
      :elementsPerPageProp="'10'"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :editar="true"
      :ordemProp="ordem"
      :disabledButtons="disabledButtons"
      :arrName="['viewConsultar', 'editConsultar']"
      :showDownload="false"
      :isConsultarUnimed="true"
      semRegistro="Unimed inexistente"
      @change-page="(page) => changePage(page)"
      @ordena="(ordem) => ordernaTable(ordem)"
      @clickButton="(obj) => clickItem(obj)"
    />

    <WarningModal v-model="warning" :errObj="wrnObj" />

    <overlay-loading v-model="loadingAll" />

    <error-modal v-model="error" :errObj="errObj" :titulo="normalErr ? 'Atualização' : 'Há algo errado.'">
      <div slot="footer-buttons">
        <v-row v-if="normalErr">
          <v-col cols="auto">
            <button-cadu @click="error = false">
              NÃO
            </button-cadu>
          </v-col>
          <v-col cols="auto">
            <button-cadu @click="visualizar">
              SIM
            </button-cadu>
          </v-col>
        </v-row>
      </div>
    </error-modal>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import ConsultarUnimed from '@/services/ConsultarUnimed/ConsultarUnimed'
import Unimed from '@/services/Unimed'
import WarningModal from '@/components/Shared/WarningModal/WarningModal'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
export default {
  components: {
    WarningModal,
    ErrorModal
  },
  data() {
    return {
      listaUnimeds: [],
      rowsHeader: [
        { text: 'Código', icon: 'repeat' },
        { text: 'Nome Fantasia', icon: 'repeat' },
        { text: 'Tipo de Cooperativa', icon: 'repeat' },
        { text: 'Tipo de Atuação', icon: 'repeat' },
        { text: 'UF', icon: 'repeat' },
        { text: 'Situação da Unimed', icon: 'repeat' }
      ],
      selected: [],
      isLoading: true,
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 1,
      ordenacao: '',
      ordem: 'asc',
      dadoUnimed: '',
      buscarHierarquia: '',
      tipoCooperativa: '',
      tipoFederacao: '',
      tipoAtuacao: '',
      grauCooperativa: '',
      registroANS: '',
      porte: '',
      uf: '',
      regiaoGeografica: '',
      municipio: '',
      nomeDirigente: '',
      ativa: null,

      disabledButtons: [true, false, false, false, false],

      error: false,
      errObj: {},
      warning: false,
      wrnObj: {},
      loadingOverlay: false,
      args: '',
      normalErr: false,
      loadingAll: false,
      idUnimed: ''
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)

    if (decoded.role === 'admin_brasil') {
      this.disabledButtons = [true, true, false, false, false]
    } else {
      this.disabledButtons = [true, false, false, false, false]
    }

    const ultimaPesquisa = localStorage.getItem('ultimaPesquisa')
    this.populateArgs(ultimaPesquisa)
    if (ultimaPesquisa) await this.getData(ultimaPesquisa)
    else await this.getData('tamanhoPagina=10')
  },
  methods: {
    async exportarUnimed() {
      let consultarUnimed = new ConsultarUnimed(this.tokenBearer, this.$appConfig.config.API)

      this.loadingAll = true

      try {
        let response = await consultarUnimed.exportar(this.getArgs(true))
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'unimeds.xlsx')
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      } finally {
        this.loadingAll = false
      }
    },
    async getData(args) {
      let consultarUnimeds = new ConsultarUnimed(this.tokenBearer, this.$appConfig.config.API)

      await consultarUnimeds
        .getConsultarUnimed(args)
        .then(({ data }) => {
          this.listaUnimeds = data.conteudo
          this.pagina = data.pagina
          this.qtPaginas = data.qtPaginas
          this.qtResultados = data.qtResultados
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.isLoading = false))
    },
    changePage(page) {
      this.pagina = page.currentPage
      this.paginate()
    },
    ordernaTable({ ordem, index }) {
      const ordenacoes = {
        0: 'versaoAtiva.codigo',
        1: 'versaoAtiva.dadosCadastrais.nomeFantasia',
        2: 'versaoAtiva.classificacao.tipoUnimed.nome',
        3: 'versaoAtiva.classificacao.tipoAtuacao.nome',
        4: 'versaoAtiva.enderecos.municipio.regiao.estado.sigla',
        5: 'versaoAtiva.dadosCadastrais.ativa'
      }

      switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          this.ordenacao = ordenacoes[index]
          this.ordem = ordem
          break

        default:
          this.ordenacao = ''
          this.ordem = 'asc'
          break
      }
      this.paginate()
    },
    pesquisar(dadoUnimed) {
      this.limparCampos()
      this.pagina = 1
      this.dadoUnimed = dadoUnimed
      this.paginate()
    },
    filtrar(filtro) {
      this.getValoresFiltro(filtro)
      this.paginate()
    },
    getValoresFiltro(filtro) {
      this.pagina = 1

      this.dadoUnimed = filtro.buscarUnimed
      this.buscarHierarquia = filtro.buscarHierarquia
      this.tipoCooperativa = filtro.tipoCooperativa
      this.tipoFederacao = filtro.tipoFederacao
      this.tipoAtuacao = filtro.tipoAtuacao
      this.grauCooperativa = filtro.grauCooperativa
      this.registroANS = filtro.registroANS
      this.porte = filtro.porte
      this.uf = filtro.uf
      this.regiaoGeografica = filtro.regiaoGeografica
      this.municipio = filtro.municipio
      this.nomeDirigente = filtro.nomeDirigente
      this.ativa = filtro.ativa
    },
    async limparFiltro() {
      this.isLoading = true
      await this.getData('tamanhoPagina=10')
      this.isLoading = false
      this.limparCampos()
    },
    limparCampos() {
      this.ordenacao = ''
      this.ordem = 'asc'
      this.dadoUnimed = ''
      this.buscarHierarquia = ''
      this.tipoCooperativa = ''
      this.tipoFederacao = ''
      this.tipoAtuacao = ''
      this.grauCooperativa = ''
      this.registroANS = ''
      this.porte = ''
      this.uf = ''
      this.regiaoGeografica = ''
      this.municipio = ''
      this.nomeDirigente = ''
      this.ativa = undefined
    },
    async paginate() {
      this.isLoading = true
      await this.getData(this.getArgs())
      localStorage.setItem('ultimaPesquisa', this.getArgs())
      this.isLoading = false
    },
    getArgs(modoExportar = false) {
      const args = new URLSearchParams()

      let json = {
        pagina: modoExportar ? '' : this.pagina,
        tamanhoPagina: modoExportar ? this.qtPaginas * 10 : 10,
        ordenacao: this.ordenacao,
        direcaoOrdenacao: this.ordem,
        dadoUnimed: this.dadoUnimed,
        hierarquiaUnimedId: this.buscarHierarquia,
        tipoUnimedId: this.tipoCooperativa,
        tipoFederacaoId: this.tipoFederacao,
        tipoAtuacaoId: this.tipoAtuacao,
        grauCooperativaId: this.grauCooperativa,
        registroAns: this.registroANS,
        porteId: this.porte,
        ufId: this.uf,
        regiaoGeograficaId: this.regiaoGeografica,
        municipioId: this.municipio,
        nomeDirigente: this.nomeDirigente,
        ativa: this.ativa
      }

      for (const j in json) {
        if (![null, undefined, ''].includes(json[j])) args.append(j, json[j])
      }

      return args
    },
    populateArgs(ultimaPesquisa) {
      let params = new URLSearchParams(ultimaPesquisa)

      this.pagina = params.get('pagina') != null ? Number(params.get('pagina')) : null
      this.qtPaginas = params.get('tamanhoPagina') != null ? Number(params.get('tamanhoPagina')) : null
      this.ordenacao = params.get('ordenacao')
      this.ordem = params.get('direcaoOrdenacao')
      this.dadoUnimed = params.get('dadoUnimed')
      this.buscarHierarquia = params.get('hierarquiaUnimedId')
      this.tipoCooperativa = params.get('tipoUnimedId')
      this.tipoFederacao = params.get('tipoFederacaoId')
      this.tipoAtuacao = params.get('tipoAtuacaoId')
      this.registroANS = params.get('registroANS')
      this.porte = params.get('porteId')
      this.uf = params.get('ufId')
      this.regiaoGeografica = params.get('regiaoGeograficaId')
      this.municipio = params.get('municipioId')
      this.nomeDirigente = params.get('nomeDirigente')
      this.ativa = params.get('ativa')
    },
    geradorParams(...params) {
      let str = ''
      for (let p of params) {
        if (p.value || p.value === false) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    },
    async clickItem(obj) {
      let unimed = this.listaUnimeds.find((unimed) => unimed.id === obj.selected[0])
      if (unimed.extinta) {
        this.warning = true
        this.wrnObj.codigo = `${unimed.codigo}`
        this.wrnObj.nomeFantasia = `${unimed.nomeFantasia}`
        this.wrnObj.razaoSocial = `${unimed.razaoSocial}`
        this.wrnObj.cnpj = `${unimed.cnpj}`
        this.wrnObj.tipoUnimed = `${unimed.tipoUnimed.nome}`
        this.wrnObj.tipoAtuacao = `${unimed.tipoAtuacao.nome}`
        this.wrnObj.uf = `${unimed.uf}`
        this.wrnObj.dataExtincao = `${unimed.dataInativacao}`
        this.wrnObj.motivoExtincao = `${unimed.motivoInativacao}`
      } else {
        this.loadingAll = true
        switch (obj.type) {
          case 'view':
            await this.abrirUnimed(obj.selected[0], false)
            break
          case 'edit':
            await this.abrirUnimed(obj.selected[0], true)
            break
        }
        this.loadingAll = false
      }
    },
    visualizar() {
      this.loadingAll = true
      localStorage.setItem('optionEdit', false)
      this.$router.push({ name: 'minhaunimed', params: { idUnimed: this.idUnimed } })
    },
    async abrirUnimed(id, canEdit) {
      localStorage.setItem('optionEdit', canEdit)
      this.idUnimed = id
      this.normalErr = false
      if (canEdit) {
        await this.editar(id)
      } else {
        this.$router.push({ name: 'minhaunimed', params: { idUnimed: id } })
      }
    },
    async editar(id) {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        await unimed.putStartEdit(id)
        this.$router.push({ name: 'minhaunimed', params: { idUnimed: id } })
      } catch (err) {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.normalErr = true
        this.error = true
      }
    }
  }
}
</script>

<style lang="sass">
.general
    color: rgba(0, 0, 0, 0.54)
    font-size: 0.875rem !important
    line-height: 1.375rem !important
    letter-spacing: 0.0071428571em

.mandatos-mobile > .table-cadu
    padding: 20px 10px !important
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu > .table
    width: 100% !important
    max-height: none !important
    overflow: auto

.mandatos > .table-cadu > .table > table
    width: 100% !important

.mandatos-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
